/**
 * The timezone authenticated surfaces render in while the user's profile is
 * still loading (FRONTEND_PATTERNS.md § Timezones).
 *
 * The profile timezone is THE display timezone; this constant covers only the
 * window before it arrives on a cold first visit (a revisit hydrates the
 * persisted profile synchronously and never sees it). Eastern rather than UTC
 * because that is where most of our users are, so the pre-profile frame is
 * usually already correct instead of usually off by hours. It is never a
 * substitute for the profile value and must not be used to FETCH day-scoped
 * data — the dashboard prefetch lets the server derive the day window from the
 * profile when the client has no persisted timezone.
 */
export const LOADING_FALLBACK_TIMEZONE = 'America/New_York';
